module.exports = __webpack_public_path__ + "static/media/planet3.5a9908b3.png";